import * as React from 'react';
import { Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import {
  IsAllowed,
  PageTitle,
  PaginatorAndListSettings,
  Search,
  Section,
  useCacheQuery,
  useQueryOptionsFromSearchParams,
} from 'gossamer-front-end';
import { AbsencePeriod } from 'cb-model';
import { useInstitutionFilter } from '../institution/useInstitutionFilter';

export const AbsencePeriodSearch = (): React.JSX.Element => {
  const initialQueryOptions = useInstitutionFilter({
    where: {
      and: [{ fieldId: 'institution_id', operator: 'eq', value: '', display: 'hidden' }],
    },
  });
  const [queryOptions, setQueryOptions] = useQueryOptionsFromSearchParams(AbsencePeriod, initialQueryOptions);
  const gCacheQueryItem = useCacheQuery(AbsencePeriod, queryOptions);

  return (
    <>
      <PageTitle
        verb="Search"
        entity={AbsencePeriod}
        subtitle="Manage absence tracking periods for institution groups"
      />

      <Section>
        <IsAllowed entity={AbsencePeriod} action="create">
          <Link to="/admin/absence-period/create">
            <Button size="sm" variant="primary">
              Create New Absence Period
            </Button>
          </Link>
          <div className="mb20px" />
        </IsAllowed>
        <PaginatorAndListSettings
          entity={AbsencePeriod}
          gCacheQuery={gCacheQueryItem}
          queryOptions={queryOptions}
          render={Search}
          setQueryOptions={setQueryOptions}
        />
      </Section>
    </>
  );
};
